(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
        });

        $timeout(function (){angular.element('#login').focus();});

        setUpContentWidth();

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        function setUpContentWidth(){
            var x = document.getElementsByClassName("remove-all");
            var y = document.getElementsByClassName("main-sidebar");
            var z = document.getElementsByClassName("content-wrapper");


            for (var i = 0; i < z.length; i++) {
                 if (z[i].classList) {
                     z[i].classList.toggle("big-box-gone");
                 }
            }


        }
    }
})();
